import React, { useRef, useCallback, useEffect, useState, useMemo } from "react";
import { components as Components } from "react-select";
import { List } from "react-window";
import styled from "styled-components";
import useElementDimensions from "hooks/useElementDimensions";
const REACT_SELECT_MAX_OPTIONS_LENGTH = 1e3;
const MAX_CONTAINER_SIZE = 300;
const Container = styled.div`
  flex: 1 1 auto;
  height: ${(props) => (props == null ? void 0 : props.height) || MAX_CONTAINER_SIZE}px;
`;
const Row = ({ data, index, setSize, style, containerWidth }) => {
  const rowRef = useRef(null);
  useEffect(() => {
    setSize(index, rowRef.current.getBoundingClientRect().height);
  }, [setSize, index, containerWidth]);
  return /* @__PURE__ */ React.createElement("div", { ref: rowRef, "data-testid": "react-window-list-item", style }, data[index]);
};
export const WindowList = ({ children, listRef = void 0, onRowsRendered = void 0, ...rest }) => {
  const containerRef = useRef(null);
  const vListRef = useRef(null);
  const [sizeMap, setSizeMap] = useState({});
  const containerDimensions = useElementDimensions(containerRef);
  const { width } = containerDimensions;
  const setSize = useCallback((index, size) => {
    setSizeMap((prev) => ({ ...prev, [index]: size }));
  }, []);
  const totalHeight = useMemo(() => {
    let sum = 0;
    for (let i = 0; i < children.length && sum < MAX_CONTAINER_SIZE; i += 1) {
      const size = sizeMap[i];
      if (size) {
        sum += parseInt(String(size), 10);
      } else {
        sum += 36;
      }
    }
    return Math.min(sum, MAX_CONTAINER_SIZE);
  }, [sizeMap, children.length]);
  const getSize = useCallback((index) => sizeMap[index] || 36, [sizeMap]);
  return /* @__PURE__ */ React.createElement(Container, { ref: containerRef, height: totalHeight, "data-testid": "infinite-loader-container" }, /* @__PURE__ */ React.createElement(
    List,
    {
      listRef: listRef || vListRef,
      style: { height: totalHeight || 300, width },
      rowCount: children.length,
      rowHeight: getSize,
      rowComponent: Row,
      rowProps: {
        data: children,
        setSize,
        containerWidth: width
      },
      onRowsRendered,
      ...rest
    }
  ));
};
const CustomMenuList = ({
  children,
  innerProps,
  ...rest
}) => {
  if (!(children == null ? void 0 : children.length) || children.length < REACT_SELECT_MAX_OPTIONS_LENGTH) {
    return /* @__PURE__ */ React.createElement(
      Components.MenuList,
      {
        ...rest,
        innerProps: {
          ...innerProps,
          // @ts-ignore
          "data-testid": "react-select-list"
        }
      },
      children
    );
  }
  return /* @__PURE__ */ React.createElement(WindowList, null, children);
};
export default CustomMenuList;
